import React from "react";
import styled from "styled-components";

import Space from "../core/Space";
import FormText from "./FormText";

const FormCheckbox = ({ children, active, onClick, ...props }) => {
  return (
    <Checkbox onClick={onClick} {...props}>
      {
        active ?
          <CheckboxImg src={`${process.env.PUBLIC_URL}/images/checkbox_active.svg`} alt="terms" />
          :
          <CheckboxImg src={`${process.env.PUBLIC_URL}/images/checkbox.svg`} alt="terms" />
      }
      <Space width={0} />

      <FormText>{children}</FormText>
    </Checkbox>
  );
};

const Checkbox = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  width: fit-content;
  border: 0px;
  background: transparent;
  cursor: pointer;
  padding: 3px 5px;
  text-align: left;
`

const CheckboxImg = styled.img`
  width: 26px;
  height: 26px;
`

export default FormCheckbox;